import { DealType, IncentiveType } from '@makemydeal/dr-shared-bff-types';

export const REQUEST_PROPOSAL = '/showroom/request-proposal';

// Deal Summary Routes - relative paths (base route comes from props)
export const DEAL_SUMMARY_REQUEST_QUOTE = '/request-quote';
export const DEAL_SUMMARY_QUOTE_REQUESTED = '/quote-requested';
export const DEAL_SUMMARY_VIEW_QUOTE = '/view-quote';
export const DEAL_SUMMARY_ACCEPTED_DEAL = '/accepted-deal';
export const DEAL_SUMMARY_DEAL_PROPOSAL = '/deal-proposal';

export const INCENTIVE_LABELS: Record<IncentiveType, string> = {
    [IncentiveType.StudentRecentGraduate]: 'Student/Recent Grad',
    [IncentiveType.MilitaryVeteran]: 'Military/Veteran',
    [IncentiveType.FirstResponder]: 'First Responder',
    [IncentiveType.PrivateOffer]: 'Private Offer',
    [IncentiveType.Loyalty]: 'Loyalty',
    [IncentiveType.Conquest]: 'Conquest'
};

export const INCENTIVE_TYPES = Object.values(IncentiveType);

export const DEAL_TYPE_LABELS: Record<DealType, string> = {
    [DealType.Finance]: 'Finance',
    [DealType.Lease]: 'Lease',
    [DealType.Cash]: 'Cash'
};

export const DEAL_TYPES = Object.values(DealType);

export const MAX_COMMENT_LENGTH = 500;

export const CO_BUYER_PREFIX = 'Co-Buyer:';
